import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { HomeRoutingModule } from "./home-routing.module";
import { HomeComponent } from "./home/home.component";
import { HomeFormsComponent } from "./home/forms/forms.component";
import { SharedModule } from "@shared/shared.module";
import { HomeService } from "./home.service";

@NgModule({
    bootstrap: [],
    declarations: [HomeComponent, HomeFormsComponent],
    exports: [],
    imports: [CommonModule, HomeRoutingModule, SharedModule],
    providers: [HomeService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule {}
